import { render } from "./LegalAlertsView.vue?vue&type=template&id=7d2143f4&scoped=true"
import script from "./LegalAlertsView.vue?vue&type=script&lang=js"
export * from "./LegalAlertsView.vue?vue&type=script&lang=js"

import "./LegalAlertsView.vue?vue&type=style&index=0&id=7d2143f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2143f4"]])

export default __exports__